// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Igbyp","modal":"Modal_modal__lrZRq","slide-down":"Modal_slide-down__3hYwN"};